import Vue from 'vue'
// import {Toast} from 'vant'
import App from './App'
import router from './router'
import $ from 'jquery'
import md5 from 'js-md5';
import 'lib-flexible/flexible'
import './utils/flexible'
import * as dd from "dingtalk-jsapi";
import '@/utils/loadVconsoleJs'


// Vue.use(Toast)
// Vue.prototype.$toast = Toast
Vue.config.productionTip = false
Vue.prototype.$md5 = md5
new Vue({
	el: '#app',
	router,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js